import { useCallback, useContext } from "react";
import { DraftContext } from "../context/DraftContext";
import { TYPES } from "../../../config/constants/typesReducers";


export const useSigners = () => {
    const {
        draftState:{draft:{signers}},
        draftDispatch
    } = useContext(DraftContext)
    // const [signers, setSigners] = useState(draft.signers);

    // const handleBlurField = () => {
    //     draftDispatch({
    //         type: TYPES.DRAFT.SIGNERS,
    //         payload: signers
    //     });
    // }
    
    const handleAddSigner = () => {
        draftDispatch({
            type: TYPES.DRAFT.ADD_SIGNER,
        });
    };

    const handleEditSigner = useCallback((signerId, target) => {
        const {name, value} = target;

        draftDispatch({
            type: TYPES.DRAFT.EDIT_SIGNER,
            payload: {
                signerId,
                name,
                value
            }
        });
    },[draftDispatch]);

    const handleRemoveSigner = (signerId) => {
        if (Object.keys(signers).length === 1) return;
        console.log('handleRemoveSigner', signerId);
        draftDispatch({
            type: TYPES.DRAFT.REMOVE_SIGNER,
            payload: signerId
        });
    }
    return({
        signers,
        handleAddSigner,
        handleEditSigner,
        handleRemoveSigner,
        // handleBlurField
    });
}
